module.exports = __webpack_public_path__ + "img/fracpacks.47b1cde1.webp";